document.addEventListener('DOMContentLoaded', () => {
  const postsElements = document.querySelectorAll('.posts-block')

  postsElements.forEach((postsElement) => {
    postsElement.classList.add('formations-block')
  })

  const otherPostsElements = document.querySelectorAll('.posts')

  otherPostsElements.forEach((otherPostsElement) => {
    otherPostsElement.classList.add('formations-block')
  })
})
